/** Frame -> loader: "report the host viewport again". */
export const HOST_VIEWPORT_REQUEST = "wexio:widget:viewport-request:v1";

/**
 * The loader reports the host viewport on the frame's `ready`, but the hooks that consume it mount
 * later (after config + auth), so that first report is lost and the loader's dedupe would never repeat
 * it. A hook calls this right after its listener is attached; the loader answers even for an unchanged
 * size. Harmless for an older loader (unknown message type).
 */
export function requestHostViewport(): void {
  if (typeof window === "undefined") return;
  window.parent?.postMessage({ type: HOST_VIEWPORT_REQUEST }, "*");
}
